module.exports = __webpack_public_path__ + "static/media/todoIcon.85cdde28.svg";